export default __webpack_public_path__ + "static/media/airlockz-cbb-banner-2.fae72723.jpg";